export const ITEMS_ANALISE_ACORDO = [
  { name: 'Data do Primeiro Vencimento', colorProp: 'corDataPrimeiroVencimento', messageProp: 'mensagemDataPrimeiroVencimento' },
  { name: 'Intervalo entre os Pagamentos', colorProp: 'corIntervaloPagamentos', messageProp: 'mensagemIntervaloPagamentos' },
  { name: 'Quantidade de Parcelas', colorProp: 'corQuantidadeParcelas', messageProp: 'mensagemQuantidadeParcelas' },
  { name: 'Taxa de Juros', colorProp: 'corTaxaJuros', messageProp: 'mensagemTaxaJuros' },
  { name: 'Honorários', colorProp: 'corTaxaHonorarios', messageProp: 'mensagemTaxaHonorarios' },
  { name: 'Descontos', colorProp: 'corTaxaDescontos', messageProp: 'mensagemTaxaDescontos' },
];
